// extracted by mini-css-extract-plugin
export default {"inputWrapper":"email_inputWrapper__7EZEq","label":"email_label__f1QdS","input":"email_input__rdpOz","dark":"email_dark__p-Auy"};